import type { Vector2, Vector3 } from "three";
import type { NodeType } from "../enum/NodeType";
import type { CompartmentDraft } from "../interfaces/CompartmentDraft";
import type { ContentItem } from "../interfaces/ContentItem";
import type { ContentNode } from "../interfaces/ContentNode";
import type { Node } from "../interfaces/Node";
import type { SubBranch } from "../interfaces/SubBranch";
import { createEqualPaddingMap } from "../user_options/InteriorOptions";

export type Nodes = ContentNode | SubBranch | AccessoryNode;
export type AccessoryNode = Node<NodeType.ACCESSORY>;

export interface BranchStats {
  size: Vector3;
  relativePosition: Vector2;
}

export interface TreeStats extends BranchStats {
  volume: number;
}
export interface GeneticStats {
  mutations: number;
}

export function createNewCompartmentDraft(): CompartmentDraft {
  return {
    count: "1",
    depth: "",
    forceOrientation: false,
    height: "",
    paddingBack: "",
    paddingBottom: "",
    paddingCubes: [],
    paddingExtraForBottom: "",
    paddingFront: "",
    paddingLeft: "",
    paddingRight: "",
    paddingTop: "",
    saveInDatabase: false,
    title: "",
    uniformPadding: true,
    width: "",
  };
}

export function createNewCompartment(
  width = 500,
  height = 500,
  depth = 500,
): ContentItem {
  return {
    count: 1,
    depth,
    forceOrientation: false,
    height,
    padding: createEqualPaddingMap(0),
    paddingCubes: [],
    paddingExtraForBottom: 0,
    title: "Gegenstand 1",
    width,
  };
}
